import React, { ReactNode } from "react";
import { default as ReactSelect } from "react-select";
import { Props as SelectProps } from "react-select";
import { Controller } from "react-hook-form";
import classNames from "classnames";
import styles from "./input.module.scss";
export interface SelectInputProps extends SelectProps {
  controller: any;
  error?: string | false;
  isRequired?: boolean;
  label?: string | ReactNode;
  name: string;
  isHorizontal?: boolean;
  icon?: ReactNode;
}
export const Select: React.FC<SelectInputProps> = ({
  controller,
  label,
  isRequired,
  isDisabled,
  name,
  placeholder,
  error,
  className,
  isHorizontal = false,
  options,
  icon,
}) => {
  const inputClass = classNames(
    styles.container,
    className,
    isHorizontal && styles.isHorizontal
  );
  const controlContainerClass = classNames(
    styles.controlContainer,
    isDisabled && styles.isDisabled
  );
  return (
    <div className={inputClass}>
      <div className={styles.label}>
        {isRequired && <span className="text-danger"> * </span>}
        {icon}
        {label && <span>{label}</span>}
      </div>

      <Controller
        control={controller}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => (
          <ReactSelect
            classNames={{
              control: () => controlContainerClass,
              dropdownIndicator: () => styles.dropdownIndicator,
              valueContainer: () => styles.valueContainer,
              input: () => styles.input,
              menu: () => styles.menu,
            }}
            options={options}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            placeholder={placeholder}
            isDisabled={isDisabled}
          />
        )}
      />

      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};
